import React, { Component } from "react";
class Banner extends Component {
  render() {
    return (
      <div className="section slide-personal-Intro-first">
        <section className="banner-section s1" id="home">
          <div className="container">
            <div className="content-text position-relative">
              <div
                className="animate-element wow delay5 fadeInDown"
                data-wow-delay="0.3s"
              >
                <h1 className="cd-headline clip is-full-width title mg-b29 text-white">
                  <span>I'm &nbsp; </span>
                  <span className="cd-words-wrapper color-d4">
                    <b className="is-visible">Suman Giri</b>
                    <b width="10%">a Developer</b>
                  </span>
                </h1>
                <p className="lt-sp03 bannerText mg-b60 text-white">
                  A physics graduate and a full-stack web developer with a passion for developing scalable web applications and tools that will drastically improve efficiency and performance. Looking forward to an esteemed organization to contribute and to sharpen my skills as a MERN developer.
                </p>
              </div>
              <div
                className="animate-element wow delay5 fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="fl-btn btn-general btn-hv-border">
                  <a
                    href="https://drive.google.com/drive/folders/1JRVlLTdkM7iLT7KLy4D5BmmoT3j0DN9Y?usp=sharing" target="_blank" rel="noreferrer"
                    className="border-corner5 f-w500 lt-sp095 text-white "
                  >
                    Download Resume
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Banner;
